import { useDeviceListStore, useLayoutStore, useUserRolePermissionStore } from 'contexts/RootStore.context';
import React, { useEffect } from 'react';
import NoPermissionsPage from 'views/NoPermissionsPage';
import HeaderSearch from './components/HeaderSearch';
import { observer } from 'mobx-react';
import { DevicesDataTable } from './components/DevicesDataTable';

export const DeviceList = observer(() => {
  const { canViewDevices } = useUserRolePermissionStore()
  const { loadDevices, totalCount, loading, reset, error } = useDeviceListStore()
  const { setItemCount, setPageError } = useLayoutStore()

  useEffect(() => {
    const abortController = new AbortController();
    if (canViewDevices) {
      loadDevices(true)
        .finally(() => {
          if (abortController.signal.aborted) {
            reset();
          }
        });
    }

    return () => {
      abortController.abort();
      reset()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setPageError(error)
  }, [error, setPageError])

  useEffect(() => {
    if (!loading) {
      setItemCount(totalCount, "Total Devices")
    }
  }, [loading, setItemCount, totalCount])


  if (!canViewDevices) {
    return <NoPermissionsPage />
  }

  return (
    <>
      <HeaderSearch />
      <DevicesDataTable />
    </>
  );
})
